import { render, staticRenderFns } from "./JeecgOrderDMainList.vue?vue&type=template&id=cca82064&scoped=true&"
import script from "./JeecgOrderDMainList.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderDMainList.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderDMainList.vue?vue&type=style&index=0&id=cca82064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca82064",
  null
  
)

export default component.exports